import { stringify } from "../../util/querystring-util";
import {
  GetComponentConversionRulesRequest,
  GetComponentConversionRulesResponse,
  UpdateComponentConversionRulesRequest,
  UpdateComponentConversionRulesResponse,
  DeleteComponentConversionRulesRequest,
  DeleteComponentConversionRulesResponse,
} from ".";
import { restResourceRequester } from "../rest-resource-requester";

interface ComponentConversionRulesRestResource {
  /**
   * GET /
   */
  getComponentConversionRules(
    request: GetComponentConversionRulesRequest,
  ): Promise<GetComponentConversionRulesResponse>;

  /**
   * PUT /
   */
  updateComponentConversionRules(
    request: UpdateComponentConversionRulesRequest,
  ): Promise<UpdateComponentConversionRulesResponse>;

  /**
   * DELETE /
   */
  deleteComponentConversionRules(
    request: DeleteComponentConversionRulesRequest,
  ): Promise<DeleteComponentConversionRulesResponse>;
}

const REST_RESOURCE_NAME = "/component-conversion-rules";

/**
 * GET /component-conversion-rules
 */
const getComponentConversionRules = restResourceRequester<
  GetComponentConversionRulesRequest,
  GetComponentConversionRulesResponse
>("GET", (request) => `${REST_RESOURCE_NAME}?${stringify(request)}`);

/**
 * PUT /component-conversion-rules
 */
const updateComponentConversionRules = restResourceRequester<
  UpdateComponentConversionRulesRequest,
  UpdateComponentConversionRulesResponse
>(
  "PUT",
  (request) => REST_RESOURCE_NAME,
  (request) => JSON.stringify(request),
);

/**
 * DELETE /component-conversion-rules
 */
const deleteComponentConversionRules = restResourceRequester<
  DeleteComponentConversionRulesRequest,
  DeleteComponentConversionRulesResponse
>(
  "DELETE",
  (request) => REST_RESOURCE_NAME,
  (request) => JSON.stringify(request),
);

export const componentConversionRulesRestResource: ComponentConversionRulesRestResource =
  {
    getComponentConversionRules: getComponentConversionRules,
    updateComponentConversionRules: updateComponentConversionRules,
    deleteComponentConversionRules: deleteComponentConversionRules,
  };
